import {
  SET_PRODUCTS, SET_LOADING, SET_ERROR, SET_PRODUCT_COUNT, LOADING_PRODUCTS,
} from '../types';
import initialState from '../initialState';

const productState = {
  ...initialState, loadingProducts: false, products: [], productCount: 0,
};

const productReducer = (state = productState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case LOADING_PRODUCTS:
      return {
        ...state,
        loadingProducts: action.value,
      };

    case SET_PRODUCT_COUNT:
      return {
        ...state,
        productCount: action.count,
      };

    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

export default productReducer;
